import { Component } from "@angular/core";
import { EnvironmentType } from "src/app/models/Enums";
import { BrandingService } from "src/app/services/branding.service";
import { ModalConfig, ModalService } from "src/app/services/modal.service";
import { environment } from "src/environments/environment";

import { ChangelogModalComponent } from "../changelog-modal/changelog-modal.component";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
  standalone: false,
})
export class FooterComponent {
  version: string = environment.appVersion;
  env: string = environment.env;
  isProduction: boolean = environment.env === EnvironmentType.Production;
  linkName: string;

  constructor(
    private modalService: ModalService,
    private brandingService: BrandingService,
  ) {
    this.linkName = this.brandingService.isAtlasCopcoBrand() ? "WIMT 1.0" : "TMSS 1.0";
  }

  onChangelogClick() {
    const modalConfig = new ModalConfig();
    modalConfig.width = "700px";
    modalConfig.maxHeight = "800px";
    modalConfig.panelClass = "changelog-modal";

    this.modalService.openModal(ChangelogModalComponent, modalConfig);
  }
}
